
<div class="token-banner">
    <div class="d-md-flex align-items-center">
        <img [src]="CDN +  'new-header/logo.svg'" class="token-logo" alt="">
    </div>
    <div>
            <h3>
                <strong> IXFI Token: </strong> Driving the next phase of IXFI’s evolution
            </h3>
            <div class="d-flex flex-column flex-md-row justify-content-center align-items-center">
                <div class="token-info ">
                    <span>
                        <img [src]="CDN + 'token/logo-icon-tf.png'" alt="">
                        Unlock cashback, staking, and trading perks with IXFI
                    </span>
                </div>
                <a [href]="IXFI_TOKEN"  target="_blank" class="token-button">
                    <strong> Secure your spot </strong>
                    <img  loading="lazy" width="20" height="20" alt="view-all" [src]="CDN + 'landing/view-all-arrow.svg'">
                </a>
            </div>
        </div>
    <div class="token-img  d-md-none d-lg-flex">
        <img [src]="CDN +  'token/token-img.png'" class="d-md-block d-none">
        <img [src]="CDN +  'token/token-img-mobile.png'" class="d-md-none">
    </div>
</div>

